import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhoneDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"phone-dynamic-island"} maskId="square-filled-radius-0-stroke-1-IconPhoneDynamicIsland"><path fillRule="evenodd" clipRule="evenodd" d="M5 23V1H19V23H5ZM10 3V4H14V3H10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPhoneDynamicIsland;
